"use strict";

exports.__esModule = true;
exports["default"] = void 0;
//@ts-check

/**
 * @param {string} s
 * @returns {string}
 */
var replicateSelector = function replicateSelector(s) {
  s = "." + s;
  var a = [s];
  for (var i = 1; i < 10; i++) {
    a[i] = a[i - 1] + s + i;
  }
  return a.join(",");
};
var _default = exports["default"] = replicateSelector;
module.exports = exports.default;